<!--Navigation Bar-->
<app-navbar>
    <h2>{{'BLOG.TILE' | translate}}</h2>
</app-navbar>

<!--Blog Posts Section-->
<section class="blog-area pt-100 pb-100">
    <div class="container">
        <div class="row">
            <div class="col-sm-6 col-lg-4 mb-5" *ngFor="let post of blogPosts">
                <div class="blog-item">
                    <!--Top Area-->
                    <div class="blog-top">
                        <!--Image-->
                        <a routerLink="/vezi-articol/{{post.id}}">
                            <img class="img-fluid" src="{{post.photoPath}}" alt="{{post.photoName}}"></a>
                        <!--Time Stamp-->
                        <span>{{post.postingDate | date:'dd-MM-yyyy HH:mm'}}</span>
                        <!--Tag/Category-->
                        <div class="post-tag yellow">
                            {{post.category}}
                        </div>
                    </div>

                    <div class="blog-bottom">
                        <ul class="post-info mb-3">
                            <!--Author Name-->
                            <li><i class="icofont-user icon-style"></i>{{post.userName}}</li>
                            <!--Comments-->
                            <!--<li><i class="icofont-ui-messaging icon-style"></i>150</li>-->
                        </ul>
                        <!--Post Title-->
                        <h3 class="post-name">
                            <a routerLink="/vezi-articol/{{post.id}}">{{(post.title.length > 25) ? (post.title | slice:0:25) + '...' : (post.title)}}</a>
                        </h3>
                        <!--Post Description-->
                        <p class="post-description">{{ (post.summary.length > 120) ? (post.summary | slice:0:120) + '...' : (post.summary) }}</p>

                        <!--Read Mode Button-->
                        <a routerLink="/vezi-articol/{{post.id}}" class="read-post-btn d-inline-block">{{'BLOG.BUTTON' | translate}}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!--Pagination Section-->


<div class="container" *ngIf="totalElements > 6">
    <ngb-pagination class="custom-pagination d-flex justify-content-center"
                    [collectionSize]="totalElements"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    [rotate]="true"
                    [maxSize]="5"
                    [boundaryLinks]="true"
                    (pageChange)="onPageChange(page)"
                    aria-label="Custom pagination">
        <ng-template ngbPaginationFirst>{{'BLOG.PAGE_F' | translate}}</ng-template>
        <ng-template ngbPaginationLast>{{'BLOG.PAGE_L' | translate}}</ng-template>
    </ngb-pagination>
</div>


<!--Footer-->
<app-footer></app-footer>
